import { ErrorPage, LoadingOverlay } from '@csp/csp-web-ui';
import { FC, PropsWithChildren } from 'react';
import { useIcfConfig } from '../hook/useIcfConfig';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { InformedConsentConfigContextProvider } from './InformedConsentConfigContextProvider';

export const InformedConsentConfigContextContent: FC<PropsWithChildren> = ({ children }) => {
  const { config, error, isLoadingInitial: isLoadingIcfConfig } = useIcfConfig();
  const commonFieldLabels = StaticContentService.getGenericBlock('webHcpInformedConsent', 'common');
  return (
    <>
      {error && <ErrorPage illustration="applicationError" label={commonFieldLabels.header.configErrorPage.label} />}

      <LoadingOverlay isLoading={isLoadingIcfConfig}>
        {config && (
          <InformedConsentConfigContextProvider
            value={{
              config,
            }}
          >
            {children}
          </InformedConsentConfigContextProvider>
        )}
      </LoadingOverlay>
    </>
  );
};
